export const getDirtyFieldsOnly = (allValues: any, dirty: any): any => {
  const extract = (values: any, dirtyObj: any): any => {
    if (typeof dirtyObj === "boolean" && dirtyObj === false) return undefined; // if dirty is false, return undefined
    if (typeof dirtyObj === "boolean" && dirtyObj === true) return values; // if dirty is true, return values

    if (Array.isArray(dirtyObj)) {
      return dirtyObj
        .map((entry, index) => {
          return entry ? extract(values[index], entry) : undefined;
        })
        .filter(Boolean); // remove undefineds
    }

    if (typeof dirtyObj === "object" && dirtyObj !== null) {
      const result: any = {};
      for (const key of Object.keys(dirtyObj)) {
        if (dirtyObj[key] !== false) {
          const extracted = extract(values[key], dirtyObj[key]);
          if (
            typeof extracted === "object" &&
            Object.keys(extracted).length === 0
          )
            continue;
          if (extracted !== undefined) {
            result[key] = extracted;
          }
        }
      }
      return Object.keys(result).length > 0 ? result : undefined;
    }

    return values; // for primitive fields
  };

  try {
    return extract(allValues, dirty);
  } catch (error) {
    return allValues;
  }
};
